import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to the top on every route change so users always see the
 * fresh page from its hero/header instead of landing wherever they were on the
 * previous page (e.g. clicking a footer link from the bottom of /home).
 *
 * Mount once at the top of the Router tree.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If a route has an anchor hash (#section), let the browser handle it naturally.
    if (hash) return;
    // `auto` (instant) feels snappier than `smooth` for full-page transitions.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
